<template>
  <div class="follow-page">
    <input-component
            type="number"
            label="Marge in aantal meters"
            v-model="marginInMeters">
    </input-component>
    <gmap-map
            :center="center"
            :zoom="12"
            :disableDoubleClickZoom="true"
            style="width: 100%; height: 90%"
            ref="map">
      <gmap-marker
          v-for="(marker, index) in locationsOfInterst"
          :key="index"
          :label="marker.title"
          :position="marker.position"
          @click="onMarkerClicked(marker, index)">
      </gmap-marker>
      <gmap-polygon :path="areaWithMargin" @click="onPolygonClicked($event)">
      </gmap-polygon>
    </gmap-map>
    <button-component @click.native="save" :submitted="submitted">Opslaan</button-component>
    <MapMarkerDetails
            v-show="showMapMarkerDetails"
            v-bind:header="modalHeaderText"
            v-bind:body="modalBodyText"
            v-bind:markerLatLngData="markerLatLngData"
            v-bind:buttonLeft="modalButtonLeft"
            v-bind:buttonRight="modalButtonRight"
            @onCloseModalClicked="onCloseModalClicked"
            @onSaveMarkerClicked="onSaveMarkerClicked">
    </MapMarkerDetails>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Client } from "../domain/client";
import { RouteName, Viewport } from '../utils/enums';
import ButtonComponent from '../components/button.component.vue';
import InputComponent from '../components/fields/input.component.vue';
import MapMarkerDetails from '../components/map.marker.details.vue';
import { Walk } from "../domain/walk";
import { Api } from '../api/api';
import { AppConfig} from "@/utils/enums";
import axios from 'axios';
import LocationService from "../services/location.service";

const locationService = new LocationService();

export default {
  name: 'connect-select-map-area',
  components: {
    ButtonComponent,
    MapMarkerDetails,
    InputComponent
  },
  data() {
    return {
      newWalk: Walk,
      center: { lat: 1, lng: 1 },
      locationsOfInterst: [], // shown markers on the map = locationsOfInterest
      areaWithMargin: [], // marker points with margin = geoPoints
      convexHullPaths: [], // temp array
      convexHull: undefined,
      marginInMeters: 250, // default
      showMapMarkerDetails: false,
      submitted: false,
      // Modal data
      modalHeaderText: 'Nieuwe locatie toevoegen' ,
      modalBodyText: 'Voer de naam van de locatie waar de cliënt naartoe wilt in:',
      modalButtonLeft: 'Annuleren',
      modalButtonRight: 'Opslaan',
      markerLatLngData: undefined
    };
  },
  watch: {
    // recalculate the geofence when the marginInMeters is changed
    marginInMeters: function () {
      // total area, with the calculated margin included
      const locationsWithMargin = locationService.addMarginPointsAroundMarker(this.locationsOfInterst, this.marginInMeters);
      // the total area (geoFence) with marging around the locations
      this.areaWithMargin = locationService.calculateGeoFence(locationsWithMargin);
    }
  },
   mounted() {
    this.$refs.map.$mapPromise.then((map) => {
      map.addListener('click', (event) => {
        this.markerLatLngData = event.latLng;
        this.showMapMarkerDetails = true;
      });
      this.getHomeLocationLatLng(this.newWalk.client.location);
    });
  },
  created() {
    this.newWalk = this.$store.getters.getNewWalk;
  },
  destroyed() {
    clearInterval(this.interval);
  },
  computed: {
    ...mapGetters(['getMarginInMeters'])
  },
  methods: {
    /**
     * Get the lat lng position of the clients GGZ-location, and push it onto the map as the first marker.
     */
    getHomeLocationLatLng: function(location) {
      // als locatie een gpsLocationLat en gpsLocationLng heeft gebruik deze dan ipv op basis van adres de gps locatie op te halen.
      if (location.gpsLocationLat && location.gpsLocationLng) {
        const lat = parseFloat(location.gpsLocationLat);
        const lng = parseFloat(location.gpsLocationLng);
        this.newWalk.walkSettings.homeLocationGeoPoint = { lat: lat, lng: lng, title: 'Woonlocatie' };
        this.geolocate();
        this.addMarker(this.newWalk.walkSettings.homeLocationGeoPoint, true, 'Woonlocatie');
      } else {
        let postalcodeToLatLngRequestUrl =
            'https://maps.googleapis.com/maps/api/geocode/json?address=' +
            location.streetNumber + location.streetName + '&components=country:NL|postal_code:'
            + location.postalCode + '&key=' + AppConfig.GOOGLE_MAPS_API_KEY;
        fetch(postalcodeToLatLngRequestUrl)
            .then(response => response.json())
            .then(resolved => {
              this.newWalk.walkSettings.homeLocationGeoPoint = resolved.results[0].geometry.location;
              this.geolocate();
              this.addMarker(this.newWalk.walkSettings.homeLocationGeoPoint, true, 'Woonlocatie');
            });
      }
    },
    /**
     * Center the map around the clients GGZ-location (this is always the starting point).
     */
    geolocate: function() {
        this.center = {
          lat: this.newWalk.walkSettings.homeLocationGeoPoint.lat,
          lng: this.newWalk.walkSettings.homeLocationGeoPoint.lng
        };
    },
    onSaveMarkerClicked: function(markerData, locationName) {
      this.addMarker(markerData, false, locationName);
      this.showMapMarkerDetails = false;
    },
    onCloseModalClicked: function() {
      this.showMapMarkerDetails = false;
    },
    /**
     * Add a marker to the map when user clicks on the map.
     */
    addMarker: function (location, isHomeLocation, locationName) {
      let point;
      if (isHomeLocation) {
        point = new google.maps.LatLng(location.lat, location.lng);
      } else {
        point = new google.maps.LatLng(location.lat(), location.lng());
      }
      // selected locations
      this.locationsOfInterst = [...locationService.addMarker(point, this.locationsOfInterst, locationName)];
      // total area, with the calculated margin included
      const locationsWithMargin = locationService.addMarginPointsAroundMarker(this.locationsOfInterst, this.marginInMeters);
      // the total area (geoFence) with marging around the locations
      this.areaWithMargin = locationService.calculateGeoFence(locationsWithMargin);
    },
    onPolygonClicked: function(event) {
      this.markerLatLngData = event.latLng;
      this.showMapMarkerDetails = true;
    },
    /**
     * Remove the marker from the map and recalculate the geofence.
     * The GGZ-location cannot be removed.
     */
    onMarkerClicked: function(marker, index) {
      if (marker.title === 'Woonlocatie') {
        return;
      }
      this.locationsOfInterst.splice(index, 1); // remove marker from the map
      // total area, with the calculated margin included
      const locationsWithMargin = locationService.addMarginPointsAroundMarker(this.locationsOfInterst, this.marginInMeters);
      // the total area (geoFence) with marging around the locations
      this.areaWithMargin = locationService.calculateGeoFence(locationsWithMargin);
    },
    save: function() {
      this.newWalk.walkSettings.geoPoints = this.areaWithMargin;
        this.newWalk.walkSettings.marginInMeters = this.marginInMeters;
      this.newWalk.walkSettings.locationsOfInterest = this.locationsOfInterst.map(marker => {
        return {
          title: marker.title,
          lat: marker.position.lat(),
          lng: marker.position.lng()
        }
      });
      if (!this.submitted) {
        this.submitted = true;
        this.$store.dispatch('SAVE_NEW_WALK', this.newWalk).then(response => {
          if (response.status === 201) { // created
            this.$router.push({ name: RouteName.CONNECT_COMPLETE });
          }
          else {
            this.$router.push({ name: RouteName.HOME });
            console.error('Er is iets fout gegaan: ' + response.status);
          }
        });
      }

    }
  }
};
</script>

<style scoped lang="scss">
.follow-page {
  padding: 0 !important;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #FFFFFF;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  min-width: 300px;
  width: 30%
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}

.modal-header {
  border-bottom: 1px solid #eeeeee;
  color: $primary;
  justify-content: space-between;
}

.modal-footer {
  border-top: 1px solid #eeeeee;
  justify-content: flex-end;
}

.modal-body {
  position: relative;
  padding: 20px 10px;
}
</style>
